import * as React from 'react';
import { useSelector } from 'react-redux';

import { CardSectionNew } from 'shared/components/CardSectionNew';
import { KpInfo } from 'shared/components/KpInfo';
import { offerDataSelector } from 'shared/selectors';
import { trackKPLinkClick } from 'shared/utils/countrySideCardIntegrationTracking';

import { GenplanContainer } from '../GenplanContainer';

export const KpInfoContainer = () => {
  const { kp, offer, agent } = useSelector(offerDataSelector);

  const handleAboutKpButtonClick = React.useCallback(() => {
    trackKPLinkClick('card_name_kp_block_in_newlist', offer, agent, kp?.id ?? null);
  }, [agent, kp?.id, offer]);

  if (!kp) {
    return null;
  }

  return (
    <CardSectionNew title={`О КП «${kp.name}»`}>
      <KpInfo {...kp} genplan={<GenplanContainer />} onAboutKPButtonClick={handleAboutKpButtonClick} />
    </CardSectionNew>
  );
};
